
import { ref } from "@vue/reactivity";
// import apiServices from "../utils/apiServices";
import { defineComponent } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
// import * as firebase from "firebase/app"
import {getAuth, signInWithEmailAndPassword} from "firebase/auth";

export default defineComponent({
	name: "Login",
	setup() {
		const objUsuario = ref({
			nb_Usuario: "",
			de_Password: "",
		});

		const alert = ref(false);
		const mensaje = "";

		const qs = useQuasar();

		return {
			objUsuario,
			alert,
			mensaje,
			qs,
		};
	},
	methods: {
		async login() {
			try {
				const auth =  getAuth();
				signInWithEmailAndPassword(auth, this.objUsuario.nb_Usuario, this.objUsuario.de_Password)
				.then(() => {
					this.$router.push("/");
				}).catch(() => {
					this.qs.notify({
						message: "Error al acceder",
						type: "negative",
					});
				})
			} catch (err: unknown) {
					this.qs.notify({
						message: "Error al acceder",
						type: "negative",
					});
			}			
		},
	},
});
